
export default {
  name: 'Overlay',
  props: {
    departure: { type: String, required: true },
    arrival: { type: String, required: true },
    plane: { type: String, required: true }
  }
}
